import { render, staticRenderFns } from "./BusinessInfoCard.vue?vue&type=template&id=195d23e1&scoped=true&"
import script from "./BusinessInfoCard.vue?vue&type=script&lang=js&"
export * from "./BusinessInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./BusinessInfoCard.vue?vue&type=style&index=0&id=195d23e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195d23e1",
  null
  
)

export default component.exports